// neotes – NMN Pulver Kaufbox (v2, 2026-10-07)
// Drei klar getrennte Kaufoptionen: 1 Beutel · 3 Beutel · 3 Beutel im Quartalsabo.
// Ersetzt die Version vom 2026-08-20, die den 3er-Einzelkauf hinter der Karte "Quartalsabo" versteckt hat.
// Preise, Grundpreise und Ersparnisse werden aus dem Produkt-JSON gelesen (keine festen Beträge im Code).
// Nur auf /products/nmn-pulver und /en/products/nmn-powder aktiv. DE und EN.
(function () {
    var cls = document.body.className;
    var DE = /path-products-nmn-pulver(\s|$)/.test(cls);
    var EN = /path-en-products-nmn-powder(\s|$)/.test(cls);
    if (!DE && !EN) return;
    
    var ABO_VARIANT = '57200562602367';   // NMN Pulver – 3 Beutel
    var SINGLE_VARIANT = '57200562569599'; // NMN Pulver – 1 Beutel
    var DEFAULT_MODE = 'subscription';     // Vorauswahl ohne ?variant= in der URL: 'onetime3' oder 'subscription'
    
    var T = EN ? {
        one: '1 pouch', three: '3 pouches', abo: '3 pouches, quarterly subscription',
        subOne: '30 g · one-time delivery',
        subThree: '90 g · one-time delivery',
        subAbo: 'Delivered every 3 months · skip or cancel anytime',
        perPouch: ' per pouch', save: 'Save ', saveAmt: ' less than 3 × 1 pouch', pct: '%'
    } : {
        one: '1 Beutel', three: '3 Beutel', abo: '3 Beutel im Quartalsabo',
        subOne: '30 g · einmalige Lieferung',
        subThree: '90 g · einmalige Lieferung',
        subAbo: 'Zustellung alle 3 Monate · jederzeit überspringen oder kündigen',
        perPouch: ' je Beutel', save: '', saveAmt: ' günstiger als 3 × 1 Beutel', pct: ' % sparen'
    };
    
    function money(cents) {
        var v = (cents / 100).toFixed(2);
        return EN ? '€' + v : v.replace('.', ',') + ' €';
    }
    function unit(cents) { return money(cents) + (EN ? '/100g' : '/100 g'); }
    
    function productJson(form) {
        var el = form.querySelector('[data-js-product-json]');
        if (!el) return null;
        try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }
    
    function build() {
        // Immer über die Kaufbox zum Formular (der Cart-Drawer legt eigene /cart/add-Formulare an)
        var box = document.querySelector('[data-neo-vswitch]');
        var form = box && box.closest('form');
        if (!form || !box || box.dataset.neoNmnReady === 'true') return false;
        var tabs = box.querySelector('.neo-vswitch__tabs');
        var tabOne = box.querySelector('.neo-vswitch__tab[data-variant-id="' + SINGLE_VARIANT + '"]');
        var tabThree = box.querySelector('.neo-vswitch__tab[data-variant-id="' + ABO_VARIANT + '"]');
        if (!tabs || !tabOne || !tabThree) return false;
        
        var p = productJson(form);
        if (!p) return false;
        var vOne = p.variants.filter(function (v) { return String(v.id) === SINGLE_VARIANT; })[0];
        var vThree = p.variants.filter(function (v) { return String(v.id) === ABO_VARIANT; })[0];
        var alloc = vThree && vThree.selling_plan_allocations && vThree.selling_plan_allocations[0];
        if (!vOne || !vThree) return false;
        
        var aboPrice = alloc ? alloc.price : null;
        var aboUnit = alloc ? alloc.unit_price : null;
        // Ersparnis des 3ers gegenüber 3 × 1 Beutel: nur als Hinweis-Badge, nicht als Streichpreis
        // (ein Streichpreis braucht nach PAngV einen echten früheren Preis; der kommt nur aus compare_at_price)
        var threeSaving = vOne.price * 3 - vThree.price;
        var threeCompare = vThree.compare_at_price && vThree.compare_at_price > vThree.price ? vThree.compare_at_price : null;
        var aboPct = aboPrice != null ? Math.round(100 - aboPrice / vThree.price * 100) : 0;
        
        function fill(tab, title, sub, price, compare, unitCents, badge, perPouchCents) {
            var titleEl = tab.querySelector('.neo-vswitch__title');
            if (titleEl) titleEl.textContent = title;
            var left = tab.querySelector('.neo-vswitch__tab-left');
            if (left) {
                var old = left.querySelector('.neo-nmn-sub'); if (old) old.remove();
                var s = document.createElement('span'); s.className = 'neo-nmn-sub';
                s.textContent = sub + (perPouchCents ? ' · ' + money(perPouchCents) + T.perPouch : '');
                left.appendChild(s);
            }
            var priceEl = tab.querySelector('.neo-vswitch__price');
            if (priceEl) {
                priceEl.innerHTML = (compare && compare > price ? '<s class="neo-vswitch__compare-price">' + money(compare) + '</s>' : '') +
'<span class="neo-vswitch__sale-price">' + money(price) + '</span>';
            }
            var u = tab.querySelector('.neo-vswitch__unit-price');
            if (u && unitCents) u.textContent = unit(unitCents);
            var oldB = tab.querySelector('.neo-nmn-badge'); if (oldB) oldB.remove();
            if (badge) {
                var b = document.createElement('span'); b.className = 'neo-nmn-badge'; b.textContent = badge;
                tab.appendChild(b);
            }
        }
        
        // Karte 3: Abo – Klon der 3er-Karte
        var tabAbo = tabThree.cloneNode(true);
        tabAbo.dataset.neoMode = 'subscription';
        tabAbo.removeAttribute('data-panel-id'); tabAbo.removeAttribute('aria-controls');
        tabThree.dataset.neoMode = 'onetime3';
        tabOne.dataset.neoMode = 'onetime1';
        tabs.appendChild(tabAbo);
        
        fill(tabOne, T.one, T.subOne, vOne.price, null, vOne.unit_price, null, null);
        fill(tabThree, T.three, T.subThree, vThree.price, threeCompare, vThree.unit_price,
            threeSaving > 0 ? money(threeSaving) + T.saveAmt : null, Math.round(vThree.price / 3));
            if (aboPrice != null) {
                fill(tabAbo, T.abo, T.subAbo, aboPrice, vThree.price, aboUnit, aboPct > 0 ? T.save + aboPct + T.pct : null, Math.round(aboPrice / 3));
            } else {
                tabAbo.remove();
            }
            
            // Abo-Block der Shopify-Subscriptions-App bleibt im DOM (liefert selling_plan), wird aber nicht mehr angezeigt.
            // Selektoren mit body-Klasse: assets/neotes-custom.css enthält seit 2026-08-20 NMN-spezifische Grid-Regeln
            // (body.path-products-nmn-pulver .neo-vswitch__tab[data-variant-id="57200562602367"] .neo-vswitch__tab-left {display:grid !important}),
            // die hier überschrieben werden müssen.
            var B = 'body.path-products-nmn-pulver .neo-nmn-kaufbox ,body.path-en-products-nmn-powder .neo-nmn-kaufbox ';
            function rule(sel, decl) {
                return B.split(',').map(function (b) { return b + sel; }).join(',') + '{' + decl + '}';
            }
            var style = document.createElement('style');
            style.textContent =
'.path-products-nmn-pulver .shopify_subscriptions_app_block,.path-en-products-nmn-powder .shopify_subscriptions_app_block{display:none!important}' +
            rule('.neo-vswitch__tabs', 'display:grid!important;grid-template-columns:1fr!important;gap:10px!important') +
            rule('.neo-vswitch__panels', 'display:none!important') +
            rule('.neo-vswitch__tab', 'display:block!important;padding:14px 16px!important;border-radius:16px!important;position:relative') +
            rule('.neo-vswitch__tab.is-active', 'border-color:#3B716E!important;box-shadow:0 8px 20px rgba(0,0,0,.06)!important') +
            rule('.neo-vswitch__tab-top', 'display:flex!important;align-items:flex-start!important;justify-content:space-between!important;gap:16px!important') +
            rule('.neo-vswitch__tab[data-variant-id] .neo-vswitch__tab-left', 'display:flex!important;grid-template-columns:none!important;flex-direction:column!important;flex-wrap:nowrap!important;align-items:flex-start!important;gap:3px!important;row-gap:3px!important;column-gap:0!important;min-width:0;padding-left:30px!important;position:relative;text-align:left!important') +
            rule('.neo-vswitch__radio', 'position:absolute!important;left:0!important;top:1px!important;margin:0!important') +
            rule('.neo-vswitch__title', 'font-weight:600!important;font-size:.98rem!important;color:#2f2f2f!important;text-align:left!important') +
            rule('.neo-nmn-sub', 'display:block;font-size:12.5px;line-height:1.35;color:#6b6b6b;text-align:left') +
            rule('.neo-vswitch__prices', 'flex:0 0 auto;display:flex;flex-direction:column;align-items:flex-end;gap:4px;text-align:right') +
            rule('.neo-vswitch__sale-price', 'font-size:1.02rem!important;font-weight:600!important;color:#2f2f2f!important') +
            rule('.neo-vswitch__tab.is-active .neo-vswitch__sale-price', 'color:#3B716E!important') +
            rule('.neo-nmn-badge', 'position:absolute;top:-10px;right:14px;background:#3B716E;color:#fff;font-size:11px;font-weight:600;letter-spacing:.02em;padding:3px 9px;border-radius:999px;line-height:1.3') +
            rule('.neo-vswitch__tab[data-neo-mode="onetime3"] .neo-nmn-badge', 'background:#fff;color:#3B716E;border:1px solid #3B716E');
            document.head.appendChild(style);
            box.classList.add('neo-nmn-kaufbox');
            
            function aboRadio(type) {
                return form.querySelector('.shopify_subscriptions_app_block[data-variant-id="' + ABO_VARIANT + '"] input[data-radio-type="' + type + '"]');
            }
            function setMode(mode) {
                box.dataset.neoMode = mode;
                [tabOne, tabThree, tabAbo].forEach(function (t) {
                    var on = t.dataset.neoMode === mode;
                    t.classList.toggle('is-active', on);
                    t.setAttribute('aria-selected', on ? 'true' : 'false');
                });
                if (mode === 'onetime1') return;
                var r = aboRadio(mode === 'subscription' ? 'selling_plan' : 'one_time_purchase');
                if (r && !r.checked) r.click();
                var sp = form.querySelector('input[name="selling_plan"]');
                if (sp) sp.value = mode === 'subscription' && r ? (r.dataset.sellingPlanId || '') : '';
            }
            // Reihenfolge: erst Variantenwechsel durch das Theme (Klick auf 3er-Karte), dann Kaufart setzen
            var programmatic = false;
            function selectThreeVariant() {
                if (box.dataset.neoCurrentVariant === ABO_VARIANT) return;
                programmatic = true;
                try { tabThree.click(); } finally { programmatic = false; }
            }
            tabAbo.addEventListener('click', function (e) {
                e.stopImmediatePropagation();
                selectThreeVariant();
                setMode('subscription');
            }, true);
            tabThree.addEventListener('click', function () {
                if (programmatic) return;
                setTimeout(function () { setMode('onetime3'); }, 0);
            });
            tabOne.addEventListener('click', function () { setTimeout(function () { setMode('onetime1'); }, 0); });
            form.addEventListener('variant:change', function (ev) {
                var v = ev.detail && ev.detail.variant; if (v) box.dataset.neoCurrentVariant = String(v.id);
            });
            // Theme-Klasse nach jedem Variantenwechsel wieder auf unsere drei Karten abbilden
            var obs = new MutationObserver(function () {
                var mode = box.dataset.neoMode; if (!mode) return;
                [tabOne, tabThree, tabAbo].forEach(function (t) {
                    var on = t.dataset.neoMode === mode;
                    if (t.classList.contains('is-active') !== on) t.classList.toggle('is-active', on);
                });
            });
            obs.observe(tabs, { attributes: true, subtree: true, attributeFilter: ['class'] });
            
            // Vorauswahl: expliziter ?variant= in der URL wird respektiert, sonst 3 Beutel (DEFAULT_MODE)
            var urlVariant = new URL(window.location.href).searchParams.get('variant');
            var checked = form.querySelector('.neo-vswitch__real-radio:checked');
            box.dataset.neoCurrentVariant = checked ? checked.value : SINGLE_VARIANT;
            if (urlVariant === SINGLE_VARIANT) {
                setMode('onetime1');
            } else if (urlVariant === ABO_VARIANT) {
                setMode(DEFAULT_MODE);
            } else {
                selectThreeVariant();
                setMode(DEFAULT_MODE);
            }
            box.dataset.neoNmnReady = 'true';
            return true;
        }
        
        function boot() {
            if (build()) return;
            var n = 0, t = setInterval(function () { n++; if (build() || n > 40) clearInterval(t); }, 150);
        }
        document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
    })();
    